import Peer from 'skyway-js'

export const peer = new Peer({ key: process.env.REACT_APP_SKYWAY_KEY || '' })
